import * as React from 'react'
import { cn } from '@/lib/utils'

interface CardProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export function Card({ children, className, style }: CardProps) {
  return (
    <div
      style={style}
      className={cn('bg-surface border border-border rounded-lg shadow-card p-6', className)}
    >
      {children}
    </div>
  )
}

interface SectionTitleProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export function SectionTitle({ children, className, style }: SectionTitleProps) {
  return (
    <div
      style={style}
      className={cn(
        'text-[0.8rem] font-bold text-accent uppercase tracking-[0.06em] mb-4 pb-2 border-b border-border',
        className,
      )}
    >
      {children}
    </div>
  )
}

interface ErrorBoxProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export function ErrorBox({ children, className, style }: ErrorBoxProps) {
  return (
    <div
      style={style}
      className={cn(
        'bg-danger-bg border border-danger-border text-danger-text rounded-md px-4 py-[0.85rem] mb-4 text-sm',
        className,
      )}
    >
      {children}
    </div>
  )
}
